/**
 * Banking details of the Come Back Alive
 */
export const donationsCBA = {
  swift: {
    name: {
      value: 'CO \'INTERNATIONAL CHARITABLE FOUNDATION \'COME BACK ALIVE\'\nOffice address: 32, Bohdana Hmelnytskoho St., office 41, Kyiv',
      isLabelVisible: true,
      label: 'Company Name',
    },
    euro: {
      value: 'UA093052990000026004025029786',
      isLabelVisible: true,
      label: 'IBAN Code (Euro)',
    },
    usd: {
      value: 'UA173052990000026009035028620',
      isLabelVisible: true,
      label: 'IBAN Code (US Dollar)',
    },
    sek: {
      value: 'UA473052990000026009035019253',
      isLabelVisible: true,
      label: 'IBAN Code (SEK)',
    },
    pln: {
      value: 'UA933052990000026001045027448',
      isLabelVisible: true,
      label: 'IBAN Code (PLN)',
    },
    nok: {
      value: 'UA173052990000026001005022621',
      isLabelVisible: true,
      label: 'IBAN Code (NOK)',
    },
    gbp: {
      value: 'UA043052990000026002035022690',
      isLabelVisible: true,
      label: 'IBAN Code (GBP)',
    },
    czk: {
      value: 'UA503052990000026007015024657',
      isLabelVisible: true,
      label: 'IBAN Code (CZK)',
    },
    chf: {
      value: 'UA143052990000026009005017456',
      isLabelVisible: true,
      label: 'IBAN Code (CHF)',
    },
    bankName: {
      value: 'JSC CB "PRIVATBANK", 1D HRUSHEVSKOHO STR., KYIV, 01001, UKRAINE',
      isLabelVisible: true,
      label: 'Name of the bank',
    },
    bankSwiftCode: {
      value: 'PBANUA2XXXX',
      isLabelVisible: true,
      label: 'Bank SWIFT Code',
    },
    purposeOfPayment: {
      value: 'Charitable donation',
      isLabelVisible: true,
      label: 'Purpose of payment',
    },
  },
  crypto: {
    bitcoin: {
      value: 'bc1qkd5az2ml7dk5j5h672yhxmhmxe9tuf97j39fm6',
      isLabelVisible: true,
      label: 'BITCOIN WALLET',
    },
    etherium: {
      value: '0xa1b1bbB8070Df2450810b8eB2425D543cfCeF79b\n0x93Bda139023d582C19D70F55561f232D3CA6a54c',
      isLabelVisible: true,
      label: 'ETHEREUM (eth, usdt, usdc)',
    },
    trc20: {
      value: 'TX9aNri16bSxVYi6oMnKDj5RMKAMBXWzon',
      isLabelVisible: true,
      label: 'TRC20 (tether)',
    },
    solana: {
      value: '8icxpGYCoR8SRKqLYsSarcAjBjBPuXAuHkeJjJx5ju7a',
      isLabelVisible: true,
      label: 'Solana (sol)',
    },
  },
  ukraine: {
    oschadbank: {
      iban: {
        value: 'UA223226690000026007300905964',
        isLabelVisible: true,
        label: 'IBAN',
      },
      code: {
        value: '39696398',
        isLabelVisible: true,
        label: 'ЄДРПОУ / Reference number of the organisation',
      },
      receiver: {
        value: 'Благодійна Організація «Міжнародний благодійний фонд «Повернись живим»',
        isLabelVisible: true,
        label: 'Отримувач / Payee',
      },
      purpose: {
        value: 'Благодійна пожертва захисникам України',
        isLabelVisible: true,
        label: 'Призначення платежу / Purpose of payment',
      },
    },
    privatbank: {
      iban: {
        value: 'UA383052990000026005015017860',
        isLabelVisible: true,
        label: 'IBAN',
      },
      code: {
        value: '39696398',
        isLabelVisible: true,
        label: 'ЄДРПОУ / Reference number of the organisation',
      },
      receiver: {
        value: 'Благодійна Організація «Міжнародний благодійний фонд «Повернись живим»',
        isLabelVisible: true,
        label: 'Отримувач / Payee',
      },
      purpose: {
        value: 'Благодійна пожертва захисникам України',
        isLabelVisible: true,
        label: 'Призначення платежу / Purpose of payment',
      },
    },
  },
};

/**
 * Banking details of the East SOS
 */
export const donationsEastSOS = {
  usd: {
    receiver: {
      value: 'Сharitable organization ”Charity Foundation “East-SOS“',
      isLabelVisible: true,
      label: 'Receiver',
    },
    iban: {
      value: 'UA893005280000026007455028483, ОТP BANK',
      isLabelVisible: true,
      label: 'IBAN',
    },
    swift: {
      value: 'OТPVUAUK',
      isLabelVisible: true,
      label: 'SWIFT',
    },
    bankCode: {
      value: '300528',
      isLabelVisible: true,
      label: 'Bank code (MFO)',
    },
    orgNumber: {
      value: '39764400',
      isLabelVisible: true,
      label: 'Reference number of the organisation',
    },
    correspondentBank: {
      value: 'Deutsche Bank Trust Company Americas, 60 Wall Street New York, NY 10005, USA, № 04448427',
      isLabelVisible: true,
      label: 'Correspondent bank',
    },
    swift2: {
      value: 'BKTRUS33',
      isLabelVisible: true,
      label: 'SWIFT',
    },
    paypal: {
      value: 'julia_samo@hotmail.com',
      isLabelVisible: true,
      label: 'PayPal',
    },
    findo: {
      value: 'https://www.fin.do/blog/89_how-to-support-ukraine-with-fin-do',
      isLabelVisible: true,
      label: 'Fin.do website',
    },
    findo2: {
      value: '5168 7450 3091 9036 (UAH)\n5168 7450 2161 1964 (EUR)\n5168 7450 3132 3527 (USD)',
      isLabelVisible: true,
      label: 'Fin.do accounts',
    },
  },
  eur: {
    receiver: {
      value: 'Сharitable organization ”Charity Foundation “East-SOS“',
      isLabelVisible: true,
      label: 'Receiver',
    },
    iban: {
      value: 'UA893005280000026007455028483, ОТP BANK',
      isLabelVisible: true,
      label: 'IBAN',
    },
    swift: {
      value: 'OТPVUAUK',
      isLabelVisible: true,
      label: 'SWIFT',
    },
    bankCode: {
      value: '300528',
      isLabelVisible: true,
      label: 'Bank code (MFO)',
    },
    orgNumber: {
      value: '39764400',
      isLabelVisible: true,
      label: 'Reference number of the organisation',
    },
    correspondentBank: {
      value: 'Commerzbahk AG, Frankfurt am Main, Germany, № 400 8880064 01',
      isLabelVisible: true,
      label: 'Correspondent bank',
    },
    swift2: {
      value: 'COBA DE FF',
      isLabelVisible: true,
      label: 'SWIFT',
    },
    correspondentBank2: {
      value: 'Deutsche Bank AG, Frankfurt am Main, Germany, № 100 947 4974 0000',
      isLabelVisible: true,
      label: 'Or correspondent bank',
    },
    swift3: {
      value: 'DEUT DE FF',
      isLabelVisible: true,
      label: 'SWIFT',
    },
    paypal: {
      value: 'julia_samo@hotmail.com',
      isLabelVisible: true,
      label: 'PayPal',
    },
    findo: {
      value: 'https://www.fin.do/blog/89_how-to-support-ukraine-with-fin-do',
      isLabelVisible: true,
      label: 'Fin.do website',
    },
    findo2: {
      value: '5168 7450 3091 9036 (UAH)\n5168 7450 2161 1964 (EUR)\n5168 7450 3132 3527 (USD)',
      isLabelVisible: true,
      label: 'Fin.do accounts',
    },
  },
  uah: {
    receiver: {
      value: 'Благодійна організація «Благодійний фонд «Восток-СОС»',
      isLabelVisible: true,
      label: 'Отримувач / Receiver',
    },
    orgNumber: {
      value: '39764400',
      isLabelVisible: true,
      label: 'Код ЄДРПОУ / Reference number of the organisation',
    },
    iban: {
      value: 'UA893005280000026007455028483',
      isLabelVisible: true,
      label: 'IBAN',
    },
    bankCode: {
      value: 'АТ «ОТП Банк», м Київ, Україна МФО: 300528',
      isLabelVisible: true,
      label: 'Банк отримувач / Bank',
    },
    purpose: {
      value: 'Благодійний внесок',
      isLabelVisible: true,
      label: 'Призначення платежу / Payment purpose',
    },
    paypal: {
      value: 'julia_samo@hotmail.com',
      isLabelVisible: true,
      label: 'PayPal',
    },
    findo: {
      value: 'https://www.fin.do/blog/89_how-to-support-ukraine-with-fin-do',
      isLabelVisible: true,
      label: 'Fin.do website',
    },
    findo2: {
      value: '5168 7450 3091 9036 (UAH)\n5168 7450 2161 1964 (EUR)\n5168 7450 3132 3527 (USD)',
      isLabelVisible: true,
      label: 'Fin.do accounts',
    },
  },
};

/**
 * Banking details of the Humanitarian Mission Proliska
 */
export const donationsProliska = {
  anyBank: {
    iban: {
      value: 'UA193515330000026003052109919',
      isLabelVisible: true,
      label: 'IBAN',
    },
    orgNumber: {
      value: '35699353',
      isLabelVisible: true,
      label: 'Код ЄДРПОУ / Reference number of the organisation',
    },
    receiver: {
      value: 'ГО «ПРОЛІСКА» / Humanitarian Mission ‘Proliska’',
      isLabelVisible: true,
      label: 'Отримувач / Receiving Organisation',
    },
    purpose: {
      value: 'Благодійний внесок / Charitable Donation',
      isLabelVisible: true,
      label: 'Призначення платежу / Purpose of Transfer',
    },
  },
  swift: {
    name: {
      value: 'ГО «ПРОЛІСКА» / GO PROLISKA GROMADS’KA ORGANIZACIYA (Public Organization)',
      isLabelVisible: true,
      label: 'Назва організації / Name of Organisation',
    },
    ibanEur: {
      value: 'UA833515330000026007052114063',
      isLabelVisible: true,
      label: 'IBAN Code EUR (Євро)',
    },
    ibanUsd: {
      value: 'UA673515330000026008052118488',
      isLabelVisible: true,
      label: 'IBAN Code USD (Долар США)',
    },
    bankName: {
      value: 'JSC CB «PRIVATBANK», 1D HRUSHEVSKOHO STR., KYIV, 01001, UKRAINE',
      isLabelVisible: true,
      label: 'Назва банку / Name of the bank',
    },
    swift: {
      value: 'PBANUA2X',
      isLabelVisible: true,
      label: 'SWIFT code банку / Bank SWIFT Code',
    },
    purpose: {
      value: 'Charitable donation to Humanitarian Mission',
      isLabelVisible: true,
      label: 'Призначення платежу / Purpose of payment',
    },
  },
};

/**
 * Banking details of the Voices of Children Foundation
 */
export const donationsVoicesOfChildren = {
  crypto: {
    btc: {
      value: '3QZHY6M1ZbiPXDajm5Hwvuecsk2R5SF74d',
      isLabelVisible: true,
      label: 'BTC (min 0.0003 BTC)',
    },
    eth: {
      value: '0xe481387CA21AeA113180a184d14B64D804027deb',
      isLabelVisible: true,
      label: 'ETH (min 0.003 ETH)',
    },
    USDT: {
      value: 'TTGy6sfJXQe7dMHQcjBhSMuLcXbByGv5yW',
      isLabelVisible: true,
      label: 'USDT TRC20 (min 3 USDT)',
    },
  },
  uah: {
    orgNumber: {
      value: '43381277',
      isLabelVisible: true,
      label: 'ЄДРПОУ / Reference number of the organisation',
    },
    iban: {
      value: 'UA 32 305299 00000 2600 5025007707',
      isLabelVisible: true,
      label: 'IBAN',
    },
    bank: {
      value: 'АТ КБ «ПРИВАТБАНК», м. Київ / JSC CB "PRIVATBANK", Kyiv',
      isLabelVisible: true,
      label: 'Банк / Bank',
    },
    purpose: {
      value: 'Благодійна допомога / Charitable assistance',
      isLabelVisible: true,
      label: 'Призначення платежу / Purpose of payment',
    },
    monobank: {
      value: 'UA 32 305299 00000 2600 5025007707',
      isLabelVisible: true,
      label: 'Для поповнення рахунку фонду через Monobank. Вкладка: "Платіж за IBAN" / For those who use Monobank. Open the tab: "IBAN payment"',
    },
  },
  eur: {
    orgName: {
      value: 'Благодійний фонд Голоси дітей / The Voices of Children Foundation',
      isLabelVisible: true,
      label: 'Назва підприємства / Company Name',
    },
    iban: {
      value: 'UA273052990000026004015003154',
      isLabelVisible: true,
      label: 'IBAN',
    },
    bank: {
      value: 'JSC CB "PRIVATBANK", 1D HRUSHEVSKOHO STR., KYIV, 01001, UKRAINE',
      isLabelVisible: true,
      label: 'Банк / Bank',
    },
    swift: {
      value: 'PBANUA2X',
      isLabelVisible: true,
      label: 'SWIFT код банку / Bank SWIFT Code',
    },
    address: {
      value: 'UA 04070 м Київ вул Набережно-Хрещатицька б.35 кв.72',
      isLabelVisible: true,
      label: 'Адреса фонду / Company address',
    },
    account1: {
      value: '400886700401',
      isLabelVisible: true,
      label: 'Рахунок у банку-кореспонденті 1 / Account in the correspondent bank 1',
    },
    swift1: {
      value: 'COBADEFF',
      isLabelVisible: true,
      label: 'SWIFT Code банку-кореспондента 1 / SWIFT Code of the correspondent bank 1',
    },
    bank1: {
      value: 'Commerzbank AG, Frankfurt am Main, Germany',
      isLabelVisible: true,
      label: 'Банк-кореспондент 1 / Correspondent bank 1',
    },
    account2: {
      value: '6231605145',
      isLabelVisible: true,
      label: 'Рахунок у банку-кореспонденті 2 / Account in the correspondent bank 2',
    },
    swift2: {
      value: 'CHASDEFX',
      isLabelVisible: true,
      label: 'SWIFT Code банку-кореспондента 2 / SWIFT Code of the correspondent bank 2',
    },
    bank2: {
      value: 'J.P.MORGAN AG, FRANKFURT AM MAIN, GERMANY',
      isLabelVisible: true,
      label: 'Банк-кореспондент 2 / Correspondent bank 2',
    },
  },
  usd: {
    orgName: {
      value: 'Благодійний фонд Голоси дітей / The Voices of Children Foundation',
      isLabelVisible: true,
      label: 'Назва підприємства / Company Name',
    },
    iban: {
      value: 'UA543052990000026005005003680',
      isLabelVisible: true,
      label: 'IBAN',
    },
    bank: {
      value: 'JSC CB "PRIVATBANK", 1D HRUSHEVSKOHO STR., KYIV, 01001, UKRAINE',
      isLabelVisible: true,
      label: 'Банк / Bank',
    },
    swift: {
      value: 'PBANUA2X',
      isLabelVisible: true,
      label: 'SWIFT код банку / Bank SWIFT Code',
    },
    address: {
      value: 'UA 04070 м Київ вул Набережно-Хрещатицька б.35 кв.72',
      isLabelVisible: true,
      label: 'Адреса фонду / Company address',
    },
    account1: {
      value: '001-1-000080',
      isLabelVisible: true,
      label: 'Рахунок у банку-кореспонденті 1 / Account in the correspondent bank 1',
    },
    swift1: {
      value: 'CHASUS33',
      isLabelVisible: true,
      label: 'SWIFT Code банку-кореспондента 1 / SWIFT Code of the correspondent bank 1',
    },
    bank1: {
      value: 'JP Morgan Chase Bank, New York ,USA',
      isLabelVisible: true,
      label: 'Банк-кореспондент 1 / Correspondent bank 1',
    },
    account2: {
      value: '890-0085-754',
      isLabelVisible: true,
      label: 'Рахунок у банку-кореспонденті 2 / Account in the correspondent bank 2',
    },
    swift2: {
      value: 'IRVT US 3N',
      isLabelVisible: true,
      label: 'SWIFT Code банку-кореспондента 2 / SWIFT Code of the correspondent bank 2',
    },
    bank2: {
      value: 'The Bank of New York Mellon, New York, USA',
      isLabelVisible: true,
      label: 'Банк-кореспондент 2 / Correspondent bank 2',
    },
  },
};
